import { styled } from '@mui/material';
import { DEFAULT_TOOLBAR_HEIGHT, DEFAULT_YELLOW_LINE } from './Header/styles';

const headerHeight = DEFAULT_YELLOW_LINE + DEFAULT_TOOLBAR_HEIGHT;

export const VerticalLine = styled('div')(({ theme }) => ({
  background: theme.palette.neutral[400],
  margin: `${theme.spacing(8)} ${theme.spacing(2)}`,
  maxHeight: `calc(100vh -  (${theme.spacing(24)} + ${headerHeight}px))`,
  width: '1px',
  position: 'sticky',
  top: `${theme.spacing(12)}`
}));

export default VerticalLine;
